import * as React from 'react';
import '../../../../context/actions.js';
import '../../../../context/reducer.js';
import { useProductData } from '../../../../context/product-context-hooks.js';
import '../../../../context/ProductContext.js';
import { useCmsData } from '../../../../context/CmsContext.js';
import '../../../../hooks/use-product-view-history.js';
import { useProductDetailQueryParams } from '../../../../hooks/use-product-detail-query-params.js';
import { ProductReimbursableLogo } from './ProductReimbursableLogo.js';

const ProductReimbursableLogoContainer = ({ className  })=>{
    const { activeVariant  } = useProductData();
    const { isReimbursable  } = useProductDetailQueryParams();
    const { reimbursableLogos  } = useCmsData();
    if (!activeVariant.isInsuranceReimbursable) return null;
    return /*#__PURE__*/ React.createElement(ProductReimbursableLogo, {
        logos: reimbursableLogos,
        variant: isReimbursable ? 'alternative' : 'default',
        className: className
    });
};

export { ProductReimbursableLogoContainer };
//# sourceMappingURL=ProductReimbursableLogoContainer.js.map
